import { render, staticRenderFns } from "./configuration-relationships-steps.vue?vue&type=template&id=7fa5b801&scoped=true&"
import script from "./configuration-relationships-steps.ts?vue&type=script&lang=ts&"
export * from "./configuration-relationships-steps.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-relationships-steps.scss?vue&type=style&index=0&id=7fa5b801&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa5b801",
  null
  
)

export default component.exports